export default () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8304 2.58127L9.16873 2.58127L9.16873 9.16915L2.58085 9.16915V10.8309L9.16873 10.8309L9.16873 17.4187L10.8304 17.4187L10.8304 10.8309L17.4183 10.8308V9.16915L10.8304 9.16915L10.8304 2.58127Z" fill="#24479A" />
    </svg>
);